import { Liferay } from './liferay';

const liferayService = <T = any>(service: string, params: any) =>
    new Promise<T>((resolve, reject) => {
        try {
            Liferay.Service(service, params, (result: T) => {
                resolve(result);
            });
        } catch (err) {
            reject(err);
        }
    });

export const getTaxonomyVocabulary = async (groupId: number, name: string) => {
    const vocabularies = await liferayService<any[]>(
        '/assetvocabulary/get-group-vocabularies',
        {
            groupId,
            name,
            start: -1,
            end: -1,
            orderByComparator: null
        }
    );

    return vocabularies?.[0]?.vocabularyId ?? null;
};

export const getTaxonomyCategories = async (groupId: number, name: string) => {
    const vocabularyId = await getTaxonomyVocabulary(groupId, name);

    if (!vocabularyId) return [];

    const categories = await liferayService<any[]>(
        '/assetcategory/get-vocabulary-categories',
        {
            parentCategoryId: 0,
            vocabularyId,
            start: -1,
            end: -1,
            orderByComparator: null
        }
    );

    return categories ?? [];
};

export const getChildTaxonomyCategories = async (parentId: number) => {
    const categories = await liferayService<any[]>(
        '/assetcategory/get-child-categories',
        {
            parentCategoryId: parentId
        }
    );

    return categories ?? [];
};
